/**
 * Extrae recursivamente todos los archivos del árbol de carpetas
 */
export function extractFilesList(data) {
  const files = [];

  function traverse(nodes, projectName = "", monthName = "") {
    for (const node of nodes) {
      if (node.type === "file") {
        files.push({
          name: node.name,
          path: node.path,
          type: "file",
          cedula: node.cedula,
          participante: node.participante,
          project: projectName,
          month: monthName,
        });
      } else if (node.type === "folder" && node.children) {
        const pathParts = node.path.split("/");

        // Nivel 2 → nombre del proyecto
        if (pathParts.length === 2) {
          traverse(node.children, node.name, "");
        }
        // Nivel 3 → nombre del mes
        else if (pathParts.length === 3) {
          traverse(node.children, projectName, node.name);
        } else {
          traverse(node.children, projectName, monthName);
        }
      }
    }
  }

  traverse(data.tree);
  return files;
}

/**
 * Obtiene lista única de proyectos
 */
export function getProjects(data) {
  const projects = new Set();

  function traverse(nodes) {
    for (const node of nodes) {
      if (node.type === "folder" && node.children) {
        const pathParts = node.path.split("/");

        if (pathParts.length === 2) {
          projects.add(node.name);
        }

        traverse(node.children);
      }
    }
  }

  traverse(data.tree);
  return Array.from(projects).sort();
}

/**
 * Obtiene lista de meses para un proyecto
 */
export function getMonthsByProject(data, projectName) {
  const months = new Set();

  function traverse(nodes, currentProject = "") {
    for (const node of nodes) {
      if (node.type === "folder" && node.children) {
        const pathParts = node.path.split("/");

        if (pathParts.length === 2) {
          traverse(node.children, node.name);
        } else if (pathParts.length === 3 && currentProject === projectName) {
          months.add(node.name);
        } else {
          traverse(node.children, currentProject);
        }
      }
    }
  }

  traverse(data.tree);
  return Array.from(months).sort();
}

/**
 * Calcula estadísticas por proyecto
 */
export function getProjectStats(files) {
  const projectMap = new Map();

  files.forEach((file) => {
    if (!file.project) return;

    if (!projectMap.has(file.project)) {
      projectMap.set(file.project, { total: 0, withUser: 0, withoutUser: 0 });
    }

    const stats = projectMap.get(file.project);
    stats.total++;

    if (file.participante) stats.withUser++;
    else stats.withoutUser++;
  });

  return Array.from(projectMap.entries())
    .map(([project, stats]) => ({
      project,
      ...stats,
    }))
    .sort((a, b) => a.project.localeCompare(b.project));
}

/**
 * Calcula estadísticas por mes dentro de un proyecto
 */
export function getMonthStats(files, projectName) {
  const monthMap = new Map();

  files
    .filter((file) => file.project === projectName)
    .forEach((file) => {
      if (!file.month) return;

      if (!monthMap.has(file.month)) {
        monthMap.set(file.month, { total: 0, withUser: 0, withoutUser: 0 });
      }

      const stats = monthMap.get(file.month);
      stats.total++;

      if (file.participante) stats.withUser++;
      else stats.withoutUser++;
    });

  return Array.from(monthMap.entries())
    .map(([month, stats]) => ({
      month,
      ...stats,
    }))
    .sort((a, b) => a.month.localeCompare(b.month));
}
